import React, { useState } from 'react';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { useSelector, useDispatch } from 'react-redux';
import {
    GridMobileContainer,
    ItemDetailText,
    OnHandText,
    LoTtext,
    MdiOptions,
    UsedBytext,
    ItemCardTextMobileContainer,
    NTIconContainer,
    NTIcon,
    TIcon,
    TIconContainer,
    MaxExpirytext,
} from './InventoryBody.styled';
import TextWithInputs from '../common/textWithInputs/TextWithInputs';
import RedAlertIcon from 'src/assets/images/RedAlertIcon.svg';
import AlertMsg from '../../components/common/AlertMsg';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import { isMobileDevice } from 'src/utils/util';
import ClockAlertOutline from 'src/assets/images/ClockAlertOutline.svg';
import { setInventoryItemsDetails } from '../../redux/actions';
import { useTranslation } from 'react-i18next';

export default function InventoryBodyMobile({
    user,
    handleChange,
    index,
    setQtyVal,
    setQuantityValue,
    setItemDetails,
    clrAll,
}) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [quantity, setQuantity] = useState('');
    const [checked, setChecked] = useState(false);
    const [quantityValidation, setQuantityValidation] = useState(false);
    const checkedItemsBody = useSelector(
        (state) => state.InventoryReturnReducer.checkedItems
    );
    const handleQtyValidation = (e) => {
        setQuantityValue(e.target.value);
        setItemDetails(index, e.target.value);
    };
    useEffectWithErrorLogging(() => {
        if (Object.prototype.hasOwnProperty.call(user, 'isChecked')) {
            const items = checkedItemsBody
                .filter((item) => item != undefined)
                .map((itemData) => ({
                    ...itemData,
                    flag: itemData.onHand < itemData.used ? true : false,
                }));
            if (user.isChecked) {
                checkedItemsBody &&
                    checkedItemsBody.map((item) => {
                        if (item.checkedIndex === index) {
                            setQuantity(item.used);
                            errorValidation(item.used, item.onHand);
                            if (item.onHand < item.used) {
                                setQuantityValidation(true);
                            } else {
                                setQuantityValidation(false);
                            }
                        }
                    });
                setChecked(true);
                dispatch(setInventoryItemsDetails(items));
            } else {
                setQuantity('');
                setChecked(false);
            }
        }
    }, [user?.isChecked, checkedItemsBody?.isChecked]);

    const loading = useSelector(
        (state) => state.InventoryReturnReducer.loading
    );
    const errorValidation = (value, onHand) => {
        if (value && value > onHand) {
            user.flag = true;
        } else {
            user.flag = false;
        }
    };
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    return (
        <div>
            {loading == false ? (
                <GridMobileContainer
                    container
                    justifyContent={'space-between'}
                    direction="row"
                    mbHeight={quantityValidation ? '165px' : '140px'}
                >
                    <ItemCardTextMobileContainer
                        item
                        xs={2}
                        sm={2}
                        md={2}
                        lg={2}
                        xl={2}
                        mobile={2}
                        key={index}
                    >
                        <div
                            style={{
                                marginLeft: '-8px',
                                marginTop: isMobileDevice() ? '-6px' : '-2px',
                            }}
                        >
                            <Checkbox
                                name={user.lotSerial}
                                key={index}
                                value={user.uniqueKey}
                                checked={
                                    checked ? checked : user?.isChecked || false
                                }
                                onCheckboxSelectionChange={(e) =>
                                    handleChange(e, clrAll)
                                }
                                id="consignmentReturn-inventory-InventoryBodyMobile-lotSerial-checkbox"
                                margin={'6px 0 0 0'}
                                background={'none'}
                                checkboxBorder={'1.5px solid #555555'}
                                alignItemDirection={'center'}
                                hoverEffect={'true'}
                                disableFocusEffect={'true'}
                            />
                        </div>
                    </ItemCardTextMobileContainer>
                    <ItemCardTextMobileContainer
                        item
                        xs={6}
                        sm={6}
                        md={6}
                        lg={6}
                        xl={6}
                        mobile={6}
                    >
                        <div style={{ marginLeft: '-21px' }}>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'baseline',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <ItemDetailText isDemi>
                                    {user.cfn}
                                </ItemDetailText>
                                {countryISOCode == 'US' &&
                                    (user.salesOrg === 'S030' ? (
                                        <TIconContainer>
                                            <TIcon>{t('consignmentReturn.inventory.t')}</TIcon>
                                        </TIconContainer>
                                    ) : (
                                        <NTIconContainer>
                                            <NTIcon>{t('consignmentReturn.inventory.nt')}</NTIcon>
                                        </NTIconContainer>
                                    ))}
                            </div>
                            <ItemDetailText isRegular>
                                {user.materialDesc}
                            </ItemDetailText>
                        </div>
                    </ItemCardTextMobileContainer>
                    <ItemCardTextMobileContainer
                        item
                        xs={1}
                        sm={1}
                        md={1}
                        lg={1}
                        xl={1}
                        mobile={1}
                    ></ItemCardTextMobileContainer>
                    <ItemCardTextMobileContainer
                        item
                        xs={3}
                        sm={3}
                        md={3}
                        lg={3}
                        xl={3}
                        mobile={3}
                    >
                        <div
                            style={{
                                marginLeft: '-14px',
                                marginTop: isMobileDevice() ? '5px' : '0px',
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'baseline',
                                    justifyContent: 'space-around',
                                }}
                            >
                                <TextWithInputs
                                    name={'Qty'}
                                    placeholder={'0'}
                                    maxLength={2}
                                    inputHeight={'40px'}
                                    inputWidth={'58px'}
                                    inputBorder={
                                        quantityValidation
                                            ? '2px solid #FACFD6'
                                            : ''
                                    }
                                    alignText={'center'}
                                    fSize={'16px'}
                                    onkeyUp={(e) => {
                                        setQuantity(
                                            e.target.value
                                                ? e.target.value.replace(
                                                      /[^0-9]+/g,
                                                      ''
                                                  )
                                                : ''
                                        );
                                        setQtyVal(e.target.value);
                                        e.target.value &&
                                        e.target.value.length > 0 &&
                                        e.target.value > user.onHand
                                            ? setQuantityValidation(true)
                                            : setQuantityValidation(false);
                                        handleQtyValidation(e, user.onHand);
                                        errorValidation(
                                            e.target.value,
                                            user.onHand
                                        );
                                    }}
                                    //errorMsg = {qtyErrorMsg}
                                    value={quantity}
                                />
                                <OnHandText>&nbsp; / {user.onHand}</OnHandText>
                            </div>
                        </div>
                    </ItemCardTextMobileContainer>

                    {quantityValidation && isMobileDevice() && (
                        <span
                            style={{
                                display: 'flex',
                                marginTop: '65px',
                                marginLeft: '35px',
                            }}
                        >
                            <AlertMsg message={t('consignmentBilling.inventory.quantityExceeds')} />
                        </span>
                    )}
                    <ItemCardTextMobileContainer
                        item
                        xs={2}
                        sm={2}
                        md={2}
                        lg={2}
                        xl={2}
                        mobile={2}
                        key={index}
                    ></ItemCardTextMobileContainer>
                    <ItemCardTextMobileContainer
                        item
                        xs={5}
                        sm={5}
                        md={5}
                        lg={5}
                        xl={5}
                        mobile={5}
                        mbHeight={quantityValidation ? '63px' : '22px'}
                        mbPaddingTop={quantityValidation ? '5px' : '20px'}
                    >
                        <div
                            style={{
                                marginLeft: '-21px',
                            }}
                        >
                            <LoTtext isDemi style={{ whiteSpace: 'nowrap' }}>
                                {t('consignmentReturn.submit.lotSerial')}{' '}
                                <LoTtext isRegular>{user.lotSerial}</LoTtext>
                            </LoTtext>
                        </div>
                    </ItemCardTextMobileContainer>

                    <ItemCardTextMobileContainer
                        item
                        xs={5}
                        sm={5}
                        md={5}
                        lg={5}
                        xl={5}
                        mobile={5}
                        mbPaddingTop={quantityValidation ? '5px' : '20px'}
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                margin:
                                    user.expiryStatus === ''
                                        ? '4px auto 0 auto'
                                        : '4px auto auto 0px',
                            }}
                        >
                            {user.expiryStatus === 'EXPIRED' ? (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        margin: '0px auto auto -3px',
                                    }}
                                >
                                    <MdiOptions
                                        mbMarginLeft={'-10px'}
                                        imageSrc={RedAlertIcon}
                                    />
                                    <UsedBytext isDemi>{t('consignmentReturn.inventory.expired')}</UsedBytext>
                                    <UsedBytext isRegular>
                                        &nbsp;{user.useByDate}
                                    </UsedBytext>
                                </div>
                            ) : user.expiryStatus === 'minexpiry' ? (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    <MdiOptions
                                        mbMarginLeft={'-7px'}
                                        imageSrc={ClockAlertOutline}
                                    />
                                    <MaxExpirytext isDemi>{t('consignmentReturn.inventory.useBy')}</MaxExpirytext>
                                    <MaxExpirytext isRegular>
                                        &nbsp;{user.useByDate}
                                    </MaxExpirytext>
                                </div>
                            ) : (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    <LoTtext isDemi>{t('consignmentReturn.inventory.useBy')}</LoTtext>
                                    <LoTtext isRegular>
                                        &nbsp;{user.useByDate}
                                    </LoTtext>
                                </div>
                            )}
                        </div>
                    </ItemCardTextMobileContainer>
                </GridMobileContainer>
            ) : null}
        </div>
    );
}
